/* eslint-disable no-unused-vars */
import React, { useState } from 'react';
import { Link, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux';

import GetSellerConfig from '../components/GetSellerConfig';
import { PaymentElement, LinkAuthenticationElement, useStripe, useElements } from '@stripe/react-stripe-js' 

import config from '../config';

const CheckoutForm = ({price, products, eventDetailsInfo, isDeposit, isBalance, stripePublishableKey}) => {
    const sellerFrontendURL = config.STR_FRONTEND_URL 
    const {userInfo} = useSelector(state => state.auth) 
    const {seller} = useSelector(state => state.seller)

    // const sellerPrimaryColor1 = seller.frontEndPrimaryColor1
    // const sellerPrimaryColor2 =  seller.frontEndPrimaryColor2
    // const sellerSecondaryColor1 = seller.frontEndSecondaryColor1

    const { 
        //sellerId, sellerPrimaryColor1, sellerPrimaryColor2, sellerSecondaryColor1, sellerSecondaryColor2,
        //sellerColorSuffixDark, sellerColorSuffixMedium, sellerColorSuffixLight, sellerComponentBackgroundColor,
        sellerColorDark, sellerColorMedium, sellerColorLight,
        sellerProductPluralTerm, sellerBoolShowSitePayments, 
    } = GetSellerConfig();

    //console.log('products ', products, '\neventDetailsInfo ', eventDetailsInfo)

    // orderId, 
    //get orderId from database
    //localStorage.setItem('orderId', orderId)
    localStorage.setItem('price', price)
    localStorage.setItem('products', JSON.stringify(products))
    localStorage.setItem('eventDetailsInfo', JSON.stringify(eventDetailsInfo))
    //console.log('CheckoutForm products ', products)

    //localStorage.setItem('isDeposit', orderId)    
    localStorage.setItem('isDeposit', isDeposit)
    localStorage.setItem('isBalance', isBalance)
    localStorage.setItem('stripePublishableKey', stripePublishableKey)    
    // localStorage.setItem('sellerPrimaryColor1', sellerPrimaryColor1)
    // localStorage.setItem('sellerSecondaryColor1', sellerSecondaryColor1)
    
    //console.log('CheckoutForm stripePublishableKey ', stripePublishableKey)

    const stripe = useStripe()
    const elements = useElements()
    const [message, setMessage] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const paymentElementOptions = {
        layout: 'tabs'//loyout
    }

    const submit = async (e) => {
        e.preventDefault()
        if (!stripe || !elements) {
            return
        }
        setIsLoading(true)
        const { error } = await stripe.confirmPayment({
            elements,
            confirmParams: {
                //return_url: 'http://localhost:3000/order/confirm'//confirmStripePayment
                return_url: `${sellerFrontendURL}/order/confirm`
            } 
        })

        //console.log('userInfo.id ', userInfo.id, 'isDeposit ', isDeposit, 'error.type ', error.type)
    
        if (error.type === 'card_error' || error.type === 'validation_error') {
            setMessage(error.message)
        } else {
            setMessage('An Unexpected error occured')
        }
        setIsLoading(false)
    }
    //
    return (
        <form onSubmit={submit} id='payment-form'>
            <div className={` ${stripePublishableKey.includes('test') ? 'text-sm text-gray-600' : 'hidden'  }  text-sm text-gray-600`} >
                Test Card Number: 4242 4242 4242 4242
            </div>
            <LinkAuthenticationElement id='link-authentication-element'/>
            <PaymentElement id='payment-element' options={paymentElementOptions} />
            <button disabled={isLoading || !stripe || !elements} id='submit' 
                className='px-10 py-[6px] m-2 rounded-lg font-semibold text-white'
                style={{ backgroundColor: sellerColorDark }} >
                <span id='button-text'>
                    { isLoading ? <div>Loading...</div> : "Pay Now" }
                </span> 
            </button>
            {message && <div>{message}</div>}
        </form>
    );
};

export default CheckoutForm;


